import { render, staticRenderFns } from "./ViewverParams.vue?vue&type=template&id=5dfb9abe"
import script from "./ViewverParams.vue?vue&type=script&lang=js"
export * from "./ViewverParams.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports